<template>
  <div class="main ant-card" :style="{top:(screenHeight/2-222)+'px',right:layoutRight+'px'}">
    <div class="eyebrow">REFLEX WIRELESS · FLEET CLOUD</div>
    <div class="title">{{ $t('main.title') }}</div>
    <a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >

      <a-form-item>
        <a-input
          size="large"
          type="text"
          :placeholder="$t('user.account')"
          v-decorator="[
            'account',
            {rules: [{ required: true, type: 'email', message: $t('user.email.tip') }, { validator: handleUsernameOrEmail }], validateTrigger: 'change'}
          ]"
        >
          <a-icon slot="prefix" type="user" />
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          type="password"
          autocomplete="false"
          :placeholder="$t('user.password')"
          v-decorator="[
            'passwd',
            {rules: [{ required: true, message: $t('user.password.tip') },{ validator: this.handleEmail} ], validateTrigger: 'blur'}
          ]"
        >
          <a-icon slot="prefix" type="lock" />
        </a-input>
      </a-form-item>
      <a-form-item style="margin-top: 8px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
        >{{ $t('user.login') }}
        </a-button>
      </a-form-item>

    </a-form>
    <div>
      <a-checkbox v-model="readed">{{ $t('user.readAndAgree') }}<a
        :href="privacyUrl"
        target="_blank">{{ $t('user.UserServiceAgreement') }}</a></a-checkbox>
    </div>
    <div class="user-login-other">
      <div class="google-login">
        <!-- 兜底：只有 GSI 没起来（被网络拦掉、或 Google 把按钮渲染失败）时才显示这颗自绘按钮 -->
        <button type="button" class="google-btn" v-if="!gsiReady" @click="handleGoogleBtnClick">
          <svg class="google-btn__logo" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          <span class="google-btn__text">{{ $t('user.signInGoogle') }}</span>
        </button>
        <!-- Google 原生按钮：可见、可点，外观与点击都交给它自己（照 App 端 ALCManage 项目的做法）。
             不再做「自绘按钮 + opacity:0 覆盖层」那套：/gsi/button 出错时 Google 会把它的
             iframe 行内尺寸收成 0×0，而覆盖层那组 !important 会把这个 0×0 空壳撑满整行，
             反而把真正可点的 [role=button] 压在下面——这就是“点了没反应”的元凶。
             类名仍不能叫 g_id_signin：那是 GSI 的保留 class，gsi/client 一加载就会
             自动扫描它、抢在 initialize() 之前往里渲染，控制台会报
             "Failed to render button before calling initialize()" -->
        <div
          id="google-gsi-holder"
          class="google-gsi-holder"
          v-show="gsiReady">
        </div>
      </div>
      <div class="right-links">
        <span class="forget-password" @click="showForgetPasswordModal">
          {{ $t('user.forgetPassword') }}
        </span>
        <span class="separator">|</span>
        <router-link class="register" :to="{ name: 'register' }">{{ $t('user.regnow') }}</router-link>
      </div>
    </div>

    <!-- 找回密码弹窗：antd 把 modal 传到 body 上，#userLayout .main 那整组
         控件规则够不到它，靠 wrapClassName 在主题层单独点一次名 -->
    <a-modal
      v-model="forgetPasswordVisible"
      :title="$t('user.password.reset')"
      @cancel="handleCancelForgetPassword"
      wrapClassName="forget-modal"
      width="400px"
    >
      <template slot="footer">
        <a-button @click="handleCancelForgetPassword">{{ $t('user.action.cancel') }}</a-button>
        <a-button
          type="primary"
          @click="handleSubmitForgetPassword"
          :loading="state.forgetPasswordBtn"
          :disabled="state.forgetPasswordBtn"
        >{{ $t('user.password.reset') }}</a-button>
      </template>
      <a-form
        ref="forgetPasswordForm"
        :form="forgetPasswordForm"
      >
        <a-form-item>
          <a-input
            size="large"
            type="text"
            :placeholder="$t('user.email')"
            v-decorator="[
              'email',
              {rules: [{ required: true, type: 'email', message: $t('user.email.tip') }, { validator: handleEmail }], validateTrigger: 'change'}
            ]"
          >
            <a-icon slot="prefix" type="mail" />
          </a-input>
        </a-form-item>

        <a-row :gutter="16">
          <a-col :span="14">
            <a-form-item>
              <a-input
                size="large"
                type="text"
                :placeholder="$t('user.emailCaptcha')"
                v-decorator="[
                  'emailCaptcha',
                  {rules: [{ required: true, message: $t('user.emailCaptcha.tip') }], validateTrigger: 'blur'}
                ]"
              >
                <a-icon slot="prefix" type="safety-certificate" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-button
              class="getCaptcha"
              size="large"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getEmailCaptcha"
              v-text="!state.smsSendBtn && $t('user.getCaptcha')||(state.time+' s')"
            ></a-button>
          </a-col>
        </a-row>

        <a-form-item>
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            :placeholder="$t('user.password.format.tip')"
            v-decorator="[
              'password',
              {rules: [{ required: true, message: $t('user.password.format.tip') }], validateTrigger: 'blur'}
            ]"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            :placeholder="$t('user.password.confirm')"
            v-decorator="[
              'confirmPassword',
              {rules: [{ required: true, message: $t('user.password.confirm.tip') }, { validator: validateConfirmPassword }], validateTrigger: 'blur'}
            ]"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 滑块验证：点击登录后弹出，验证通过才提交登录 -->
    <a-modal
      v-model="sliderVisible"
      :title="$t('user.slider.title')"
      :width="400"
      :maskClosable="false"
      :destroyOnClose="true"
      wrapClassName="slider-modal"
      :footer="null"
      @cancel="cancelSlider"
    >
      <slider-captcha @success="onSliderSuccess" @fail="onSliderFail"></slider-captcha>
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import md5 from 'md5'
import axios from 'axios'
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import SliderCaptcha from '@/components/tools/SliderCaptcha'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import store from '../../store'
import Vue from 'vue'
import { ACCESS_TOKEN, USERID } from '@/store/mutation-types'
import { loadPermissionList } from '@/api/data'
import moment from 'moment/moment'
import { getI18nLanguage } from '@/locales'

/* adminSliderLogin 约定：该账号上次免滑块登录没成功，还在一小时的“必须滑块”窗口里。
   该不该弹滑块由服务端判（它才知道这个账号上次登录有没有成功），
   前端记一份只会多一个能被清掉/换浏览器就失效的假账本 */
const SLIDER_REQUIRED_CODE = -9

export default {
  components: {
    TwoStepCaptcha,
    SliderCaptcha
  },
  data () {
    return {
      privacyUrl: navigator.language.indexOf('ja') === 0 ? 'https://www.reflexwireless.com/en/terms-and-conditions-japanese/' : 'https://www.reflexwireless.com/en/terms-and-conditions/',
      readed: false,
      screenHeight: 0,
      customActiveKey: 'tab1',
      loginBtn: false,
      /* Google 原生按钮是否已经渲染出来：true 用原生按钮，false 才显示兜底的自绘按钮 */
      gsiReady: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      forgetPasswordVisible: false,
      forgetPasswordForm: this.$form.createForm(this),
      hasGetCaptcha: false,
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false,
        forgetPasswordBtn: false
      },
      qrUrl: null,
      // 滑块验证弹窗与待提交的登录信息
      sliderVisible: false,
      pendingLogin: null,
      // 窗口较窄时也留出右侧留白，面板不贴边
      layoutRight: document.body.clientWidth > 1200 ? 100 : 24
    }
  },
  computed: {
    googleLocale () {
      const localeMap = { 'zh-CN': 'zh-CN', 'ja-JP': 'ja-JP', 'en-US': 'en-US' }
      return localeMap[getI18nLanguage()] || 'en-US'
    }
  },
  created () {
    const hash = window.location.hash
    if (hash.indexOf('?redirect=') > 0) {
       const redirect = hash.split('=')[1]
       window.localStorage.setItem('redirect', redirect)
      const search = window.location.search
      if (search.indexOf('?') !== -1) {
        window.localStorage.setItem('login_search', search)
      }
    } else {
      window.localStorage.removeItem('redirect')
      window.localStorage.removeItem('login_search')
    }
    this.screenHeight = document.body.clientHeight
    this.$nextTick(() => {
      this.initSocketClient()
    })
  },
  /* 面板的垂直位置和右侧留白都是按窗口尺寸算出来的，
     窗口一变就得重算：否则面板会停在旧位置上被挤出容器，又撑出滚动条 */
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    handleResize () {
      this.screenHeight = document.body.clientHeight
      this.layoutRight = document.body.clientWidth > 1200 ? 100 : 24
    },
    // handler
    handleEmail (rule, value, callback) {
      if (/[\uFF01-\uFF5E]/.test(value)) {
        callback(new Error(this.$t('user.input.keyboard.error')))
      } else {
        callback()
      }
    },
    refreshQr (clientId, authCode) {
      this.qrUrl = `/user/auth/qr?action=login&clientId=${clientId}&authCode=${authCode}&time=${(new Date()).getTime()}`
    },
    /* 只走 JS API：脚本就绪后 initialize 一次，再把原生按钮显式渲染进 #google-gsi-holder，
       外观和点击都用 Google 自带的，不再自绘一颗再盖一层透明覆盖。
       index.html 里那个 #g_id_onload 已经去掉，
       否则 GSI 自己会先按它自动初始化一遍——两次 initialize 会报
       "called multiple times"，还会白发一次注定被中止的 /gsi/button 请求 */
    setupGoogleSignIn () {
      const gsi = window.google && window.google.accounts && window.google.accounts.id
      if (!gsi) {
        return false
      }
      /* 用 redirect 而不是 popup：popup 要靠 window.open 开选择窗，而目标环境不一定能开。
         实测一台 Chrome 156：navigator.identity 未定义、控制台报
         “Unrecognized feature: 'identity-credentials-get'”（即这个内核里 FedCM 整个不可用），
         点完按钮 0 网络请求、0 控制台输出——静默失败，什也不会发生。
         redirect 是整页跳到 Google 的网页版账号选择器再 POST 回来，
         既不依赖弹窗，也不依赖 FedCM。

         两个必须同时成立的条件，缺任一个都是静默失败：
         1) 这个绝对 URI 要在 Google Cloud 控制台登进该 OAuth 客户端的
            “已获授权的重定向 URI”（文档：该值必须与某个已授权重定向 URI 完全一致）；
            文档还说了：popup 下传了 callback 会直接忽略 login_uri，所以两者不共存。
         2) 后端要能用 POST 接住 body.credential。已实测这条链路是通的：
            往 https://cloud.reflexwireless.jp/alc/manage/google/login POST 一个假
            credential 返 200，并渲染了 googleLoginFail（nginx 确实把 /alc/ 反代到了
            keiyo-server，adminGoogleLogin 读的就是 body.credential，一行不用改）。

         login_uri 用 location.origin 拼，保证各环境只回传自己的后端，不把凭据
         泄给另一个环境；代价是每个环境的这个 URI 都要各自登记（dev 的
         localhost 不登记就测不了 Google 登录，这跟 JS 来源白名单是一样的限制）。

         另：“已获授权的 JavaScript 来源”仍必须包含当前页面 origin（含端口），
         没加时 /gsi/button 直接 403，按钮照样渲染、也接得住点击，但里面是
         一张错误页，表现就是“点了没反应”，控制台报
         The given origin is not allowed for the given client ID. */
      /* 本地调试用：下面这两个值就是 Google Cloud Console 里要登记的东西，
         打出来照抄，避免手写把 http/https、端口、末尾路径差一个字符
         （差一个字符就是静默失败：origin 没登记 → /gsi/button 403；
         redirect URI 没登记 → 跳过去后 Google 报 错误 400: redirect_uri_mismatch）。
         注：localhost 与 127.0.0.1 是两个不同的 origin，用哪个访问就要登记哪个 */
      const loginUri = window.location.origin + '/alc/manage/google/login'
      console.log('[GSI] 已获授权的重定向 URI ：', loginUri)
      console.log('[GSI] 已获授权的 JavaScript 来源：', window.location.origin)
      gsi.initialize({
        client_id: '202743444757-p0hbbr6f3kjpel1of2dv6fsi3k3krscq.apps.googleusercontent.com',
        /* 不传 auto_prompt：它不是 IdConfiguration 的字段，只存在于 HTML API 的
           #g_id_onload 上的 data-auto_prompt（库解析时会把它 delete 掉再 initialize）。
           JS API 下 One Tap 只靠显式调 google.accounts.id.prompt() 才会弹，
           我们不调，就等于关了，不需要这个开关 */
        ux_mode: 'redirect',
        login_uri: loginUri
        // 不传 callback：文档明确“按钮 redirect 用户体验模式会忽略 callback”，
        // 凭据由 Google 自己 POST 到 login_uri，不回到页内 JS
      })
      const holder = document.getElementById('google-gsi-holder')
      if (holder) {
        /* 外观参数照 App 端 ALCManage 项目的那颗原生按钮（standard / large / pill / 图标居左 /
           signin_with），差别只在 theme：这边面板是深色材质，所以用它给的暗色变体
           outline_dark（填充 #131314、文字 #FFFFFF）；想要 App 端那颗白底的，改成 'outline' 即可 */
        gsi.renderButton(holder, {
          type: 'standard',
          size: 'large',
          theme: 'outline_dark',
          /* GsiButtonConfiguration 里 text 的合法值是 signin_with / signup_with /
             continue_with / signin；旧代码写的 sign_in_with 不在表内（那是 HTML
             示例里的写法），命中不到就只能退回默认值 */
          text: 'signin_with',
          shape: 'pill',
          logo_alignment: 'left',
          locale: this.googleLocale,
          // 文档里 width 的类型是字符串（“最小宽度”，上限 400），上限内给字符串
          width: '342'
        })
        this.gsiReady = true
        /* Google 渲染失败不报错，只是把它的 iframe 行内尺寸写成 0×0：
           等它 load 完再量一次，塌掉就把兜底那颗换回来，
           不至于让人盯着一颗看不见、也点不动的空位 */
        const frame = holder.querySelector('iframe')
        if (frame) {
          frame.addEventListener('load', () => {
            if (frame.getBoundingClientRect().width < 10) {
              this.gsiReady = false
            }
          })
        }
      }
      return true
    },
    /* 脚本一直没下来（网络不通 / 被拦）时，原生按钮就是空的：
       自定义按钮点下去没有反应，也不能没有反应，总得告诉人发生了什么 */
    handleGoogleBtnClick () {
      console.log('handleGoogleBtnClick')
      const holder = document.getElementById('google-gsi-holder')
      /* 判据要是“Google 那颗真按钮在不在”，不能只判 iframe 在不在：
         实测 iframe 只是个壳，/gsi/button 出错时 Google 会把它的行内尺寸写成 0×0，
         壳还在但完全不可点；真正接得住点击的是父文档里那颗 [role=button]。
         只判 iframe 的话，正好会在这种时候静默 return，把人卡在
         “点了没反应、也没提示”里 */
      const live = holder && holder.querySelector('[role="button"]')
      if (live && live.getBoundingClientRect().width > 0) {
        // 原生按钮在覆盖层下面接住了这一跳，这里不该再点出第二个 Google 弹窗
        return
      }
      this.$message.warn(this.$t('user.google.unavailable'))
    },
    initSocketClient () {
      axios.post('/user/qr/client', { action: 'login' }).then(res => {
        var resp = res.data
        if (resp.code === 0) {
          var data = resp.data

          this.initSocket(data.clientId, data.authCode)
          this.refreshQr(data.clientId, data.authCode)
          // #g_id_onload 那个自动初始化入口已从 index.html 移除，这里不再往它身上
          // 补 data-*；login_uri 由 setupGoogleSignIn 里的 initialize 一次性给全
          var secScript = document.createElement('script')
          secScript.setAttribute('type', 'text/javascript')
          secScript.setAttribute('async', 'true')
          const host = window.location.host
          if (host === 'cloud.reflexwireless.jp') {
            secScript.setAttribute('src', 'https://accounts.google.com/gsi/client?hl=ja')
          } else {
            secScript.setAttribute('src', 'https://accounts.google.com/gsi/client?hl=en')
          }

          document.body.insertBefore(secScript, document.body.lastChild)
          secScript.addEventListener('load', () => {
            if (this.setupGoogleSignIn()) {
              return
            }
            // 脚本回调里 google 还没挂上来，就等它一会儿；始终拿不到就留给
            // handleGoogleBtnClick 给用户一句准话，比让人反复按一颗没反应的按钮强
            const startedAt = Date.now()
            const timer = window.setInterval(() => {
              if (this.setupGoogleSignIn()) {
                window.clearInterval(timer)
              } else if (Date.now() - startedAt > 8000) {
                window.clearInterval(timer)
              }
            }, 200)
          })
        }
      })
    },
    initSocket (clientId, authCode) {
      const wsuri = 'wss://www.breathmeters.net:444/qr/login/' + clientId + '/' + authCode
      this.websock = new WebSocket(wsuri)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen () {
      console.log('open')
    },
    websocketonmessage (msg) {
      try {
        var resp = JSON.parse(msg.data)
        if (resp.event === 'googleLogin') {
          const result = resp.data
          Vue.ls.set(ACCESS_TOKEN, result.session, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USERID, result.user_id, 7 * 24 * 60 * 60 * 1000)
          this.loginSuccess()
        }
      } catch (e) {

      }
    },
    websocketonerror () {
      console.log('error')
    },
    websocketclose () {
      console.log('close')
    },
    handleUsernameOrEmail (rule, value, callback) {
      const { state } = this
      if (/[\uFF01-\uFF5E]/.test(value)) {
        callback(new Error(this.$t('user.input.keyboard.error')))
        return
      }
      // const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      // if (regex.test(value)) {
      //   state.loginType = 0
      // } else {
      //   state.loginType = 1
      // }
      callback()
    },
    // 账号密码校验通过后先按「免滑块」提交：上次登录成功过的账号服务端直接放行，
    // 只有回 -9（上次免滑块没登录成功）才弹滑块，验完自动重交，不用再点一次登录
    handleSubmit (e) {
      e.preventDefault()
      const { form: { validateFields } } = this

      validateFields(['account', 'passwd'], { force: true }, (err, values) => {
        if (err) {
          return
        }
        if (!this.readed) {
          this.$message.error(this.$t('user.agreement.read'))
          return
        }
        this.pendingLogin = {
          account: values.account,
          passwd: md5(values.passwd)
        }
        this.submitLogin(null)
      })
    },
    onSliderSuccess (captchaId) {
      if (!this.pendingLogin) {
        return
      }
      this.sliderVisible = false
      this.submitLogin(captchaId)
    },
    // captchaId 为空即走免滑块通道，能不能放行由服务端这个账号的登录历史决定
    submitLogin (captchaId) {
      const loginParams = {
        account: this.pendingLogin.account,
        passwd: this.pendingLogin.passwd,
        appid: 'com.reflex.alc.manager.net'
      }
      if (captchaId) {
        loginParams.captchaId = captchaId
      }
      const { state } = this
      state.loginBtn = true
      let waitingSlider = false
      store.dispatch('Login', loginParams)
        .then(() => this.loginSuccess())
        .catch(err => {
          if (err && err.code === SLIDER_REQUIRED_CODE) {
            // 上次免滑块没登录成功，这次得补滑块；登录信息留着等下重交
            waitingSlider = true
            this.sliderVisible = true
            return
          }
          this.requestFailed(err)
        })
        .finally(() => {
          state.loginBtn = false
          // 除「等着补滑块」外都要清掉：滑块凭证是一次性的，
          // 下一次点击必须重新走一遍免滑块判定
          if (!waitingSlider) {
            this.pendingLogin = null
          }
        })
    },
    onSliderFail () {
      // 验证失败由滑块组件自动换题，页面无需处理
    },
    cancelSlider () {
      this.sliderVisible = false
      this.pendingLogin = null
    },
    genRandomChars (len, onlyNum) {
      const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      let code = ''
      for (let i = 0; i < len; i++) {
        if (onlyNum) {
          code += chars[parseInt(Math.random() * 10)]
        } else {
          code += chars[parseInt(Math.random() * 62)]
        }
      }
      return code
    },
    loginSuccess () {
      // 默认主页是 3D 运行大屏（'/' 也重定向到这里）
      this.$router.push({ name: 'dashboard3d' })
    },
    requestFailed (err) {
      const langMap = { 'ja-JP': 'ja', 'zh-CN': 'zh', 'en-US': 'en' }
      const lang = langMap[getI18nLanguage()] || 'en'
      const msg = (err && err.msg && err.msg[lang]) ? err.msg[lang] : ((err && err.msg && typeof err.msg === 'string') ? err.msg : 'There was an error with the request, please try again later.')
      this.$notification['error']({
        message: 'Error',
        description: msg,
        duration: 4
      })
    },
    // 找回密码相关方法
    showForgetPasswordModal () {
      this.forgetPasswordVisible = true
    },
    handleCancelForgetPassword () {
      this.forgetPasswordVisible = false
      this.forgetPasswordForm.resetFields()
    },
    getEmailCaptcha (e) {
      e.preventDefault()
      const { forgetPasswordForm: { validateFields }, state } = this
      const that = this
      validateFields(['email'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true

          // 调用获取邮箱验证码的API
          axios.post('/user/verify/email/send/v2', {
            email: values.email,
            appid: 'com.reflex.alc.manager.net',
            action: 'forget'
          })
            .then(res => {
              if (res.data.code === 0) {
                that.msgId = res.data.data
                this.$message.success(this.$t('user.email.captcha.send.success'))
                this.hasGetCaptcha = true
              } else {
                this.$message.error(res.data.msg || this.$t('user.email.captcha.send.fail'))
              }
            })
            .catch(() => {
              this.$message.error(this.$t('user.email.captcha.send.fail'))
            })

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)
        }
      })
    },
    validateConfirmPassword (rule, value, callback) {
      const { forgetPasswordForm } = this
      if (value && value !== forgetPasswordForm.getFieldValue('password')) {
        callback(new Error(this.$t('user.password.confirm.error')))
      } else {
        callback()
      }
    },
    handleSubmitForgetPassword () {
      const { forgetPasswordForm: { validateFields }, state } = this

      state.forgetPasswordBtn = true

      // 校验是否获取了验证码
      if (!this.hasGetCaptcha) {
        this.$message.error(this.$t('user.email.captcha.required'))
        state.forgetPasswordBtn = false
        return
      }

      const that = this
      validateFields(['email', 'emailCaptcha', 'password', 'confirmPassword'], { force: true }, (err, values) => {
        if (!err) {
          axios.post('/user/verify/email/check', {
            appid: 'com.reflex.alc.manager.net',
            msgId: that.msgId,
            verifyCode: values.emailCaptcha,
            email: values.email
          }).then(res => {
            // 调用重置密码的API
            const resetParams = {
              uCode: res.data.data,
              password: md5(values.password)
            }

            axios.post('/user/forget/pwd/reset', resetParams)
              .then(res => {
                const resp = res.data
                if (resp.code === 0) {
                  this.$message.success(this.$t('user.password.reset.success'))
                  this.forgetPasswordVisible = false
                  this.forgetPasswordForm.resetFields()
                  this.hasGetCaptcha = false
                } else {
                  this.$message.error(this.$t('user.password.reset.fail'))
                }
              })
              .catch(() => {
                this.$message.error(this.$t('user.password.reset.fail'))
              })
              .finally(() => {
                state.forgetPasswordBtn = false
              })
          }).catch(() => {
            this.$message.error(this.$t('user.email.captcha.error'))
            state.forgetPasswordBtn = false
          })
        } else {
          setTimeout(() => {
            state.forgetPasswordBtn = false
          }, 600)
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
/* 面板材质（毛玻璃、铭牌头、提交键、底部文字入口）收在 assets/user-panel.less，
   和注册页共用同一份：两边各写一遍早晚走形 */
@import '../../assets/user-panel.less';

@primary: #38B6F0;
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
@text-secondary: rgba(255, 255, 255, 0.55);

.user-layout-login {
  label {
    font-size: 13px;
    color: @text-secondary;
  }

  /* 输入框、勾选框、报错文案、取码键藏在 antd 子组件里，本文件是 scoped，
     碰不到它们，统一放在 assets/tech-theme.css 的 #userLayout 段里 */

  .forge-password {
    font-size: 13px;
  }
}

/* 第三方登录独占一行，两个文字入口在下方居中：
   挤在同一行时日文文案会溢出，也不利于扫读 */
.user-login-other {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  line-height: 1;

  .google-login {
    width: 100%;
    min-height: 42px;

    // 兜底自绘按钮（只在 GSI 没起来时出现，跟随面板的深色材质）
    .google-btn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      /* 高度要给确定值，不能写 100%：父层 .google-login 为了不让 Google 原生按钮被裁，
         已经改成只给 min-height（内容高度），百分比算不出基准，
         这颗按钮会塌成一行文字那么高 */
      height: 42px;
      padding: 0 14px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.14);
      /* 跟 Google 原生那颗的 shape:'pill' 对齐：高度 42px 正好取一半，
         两端是整圆；留着方角的话脚本加载完、换成原生按钮时圆角会跳一下 */
      border-radius: 21px;
      font-size: 13px;
      font-weight: 500;
      color: #dbe8f2;
      cursor: pointer;
      transition: all @transition;

      &__logo {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        margin-right: 8px;
      }

      &__text {
        min-width: 0;
        line-height: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &:hover .google-btn {
      background: rgba(255, 255, 255, 0.09);
      border-color: rgba(56, 182, 240, 0.45);
    }

    // Google 原生按钮本体：可见、可点，位置由文档流决定。
    // 这里和全局层都不要给它或它的 iframe 写任何尺寸 / 绝对定位 / 覆盖 ——
    // 大小交给 Google 自己按 renderButton 的 width/size 定，它那套负外边距和
    // 内部留白是自洽的算法，我们去碰它就等于造一层点不着的遮挡。
    // 类名也不能用 GSI 保留的 g_id_signin，否则脚本加载时会抢在 initialize 前自动渲染
    .google-gsi-holder {
      display: block;
      width: 100%;
    }
  }

  /* 「忘记密码 | 注册」那一行的居中与蓝色在 user-panel.less 的 .main .right-links */

  .item-icon {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.2);
    margin-left: 16px;
    vertical-align: middle;
    cursor: pointer;
    transition: color @transition;

    &:hover {
      color: @primary;
    }
  }
}

/* 勾选框与协议链接的深色适配同样收在 assets/tech-theme.css 的 #userLayout 段 */
</style>
